import { fields } from '@synergy/utils';

import { DemandItem } from '../../../models/demand-item';

export interface PositionsFormValues {
    demandItems: DemandItem[];
    startDate: Date;
    deliveryDateFrom?: Date;
    deliveryDateTo?: Date;
}

export const fieldNames = fields<PositionsFormValues>();
